<div class="grid">
  <div id="app-header">
    <static-header></static-header>
  </div>
  <main>
    <div id="app-content">
      <router-outlet></router-outlet>
    </div>
  </main>
  <div id="app-footer">
    <static-footer></static-footer>
  </div>
</div>
